import axios from 'axios';
axios.defaults.withCredentials = true;
import { fetchToken } from '../fetchToken';
const API_URL = process.env.EMAILS_API_URL;
import { logError } from '../../taskpane/utils/request';

/**
 * Get all potential assignees (Users)
 *
 * This function takes in a a salesforce object api name (typically User or Contact)
 * and a search string and returns Users or Contacts with the matching Name
 *
 * @param {string} objectApiName - Salesforce object Api name.
 * @param {string} searchString - String used to query data directly from Salesforce.
 *
 * @return {Promise} - A promise with the reponse from the lamda function.
 *
 * @throws {Error} - Throws a Error Salesforce call fails
 *
 * @example
 * // Example of how to use the function
 * const response = await assigneeSearch('User', 'Ant');
 */
export const assigneeSearch = async (objectApiName, searchString) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}calendar/search?objectApiName=${objectApiName}&query=${encodeURIComponent(searchString)}&contact=true`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    return e;
  }
};
